import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Screen } from '../../app/Frame';
import { useMeContext } from '../../app/MeContext';
import { useScreen, useToast } from '../../app/shell-context';
import { ApiError } from '../../api/client';
import { askContact, canAskContact } from '../../lib/telegram';
import { Avatar } from '../../ui/parts';
import { useSaveContact } from '../../client/api';
import { useOnboarding } from '../OnboardingContext';

/**
 * Первый вход, шаг 1: телефон и согласие. Без них `POST /api/me/children`
 * ответит `CONTACT_REQUIRED` — значит, и спрашивать надо здесь, до карточки ребёнка.
 */
export function Welcome() {
  const me = useMeContext();
  const navigate = useNavigate();
  const toast = useToast();
  const { nb, patch } = useOnboarding();
  const saveContact = useSaveContact();
  const [asking, setAsking] = useState(false);

  const digits = nb.phone.replace(/\D/g, '');
  const ready = digits.length >= 10 && nb.consent;

  useScreen('Знакомимся', {
    label: saveContact.isPending ? 'Секунду…' : 'Далее',
    disabled: !ready || saveContact.isPending,
    onClick: () => next(),
  });

  function next() {
    saveContact.mutate(
      {
        phone: nb.phone.trim(),
        source: nb.phoneFromTelegram ? 'telegram_contact' : 'form',
        consent: true,
        firstName: me.client?.firstName,
      },
      {
        onSuccess: () => navigate('/onboarding/child'),
        onError: (e) => toast(e instanceof ApiError ? e.message : 'Не получилось сохранить телефон'),
      },
    );
  }

  async function fromTelegram() {
    setAsking(true);
    const phone = await askContact();
    setAsking(false);
    if (!phone) {
      toast('Не получилось взять номер — введите вручную');
      return;
    }
    patch({ phone, phoneFromTelegram: true });
  }

  const name = me.client?.firstName?.trim();

  return (
    <Screen>
      <div className="hero">
        <Avatar name={name || 'Гость'} />
        <div className="hero-txt">
          <h2>{name ? `Здравствуйте, ${name}!` : 'Здравствуйте!'}</h2>
          <p>Имя и аккаунт взяли из Telegram — вводить не нужно</p>
        </div>
      </div>
      <p className="lead">Пара шагов до записи: телефон для связи, коротко о ребёнке и категория.</p>

      <div className="field">
        <label htmlFor="nbPhone">Телефон</label>
        <input
          id="nbPhone"
          type="tel"
          placeholder="+7 900 000-00-00"
          autoComplete="tel"
          value={nb.phone}
          onChange={(e) => patch({ phone: e.target.value, phoneFromTelegram: false })}
        />
        <span className="hint">
          Нужен, если срочно придётся отменить запись и не будет связи в Telegram.
        </span>
      </div>

      {canAskContact() ? (
        <button className="btn" disabled={asking} onClick={() => void fromTelegram()}>
          {asking ? 'Ждём Telegram…' : 'Взять номер из Telegram'}
        </button>
      ) : null}

      <label className="check">
        <input type="checkbox" checked={nb.consent} onChange={(e) => patch({ consent: e.target.checked })} />
        <span>
          Согласен на обработку персональных данных — своих и ребёнка. <u>Политика организации</u>
        </span>
      </label>
    </Screen>
  );
}
